var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
!function (t, e) {
  exports = e();
}(exports, function () {
  "use strict";

  Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (t) {
    for (var e = ((this || _global).document || (this || _global).ownerDocument).querySelectorAll(t), i = e.length; --i >= 0 && e.item(i) !== (this || _global););

    return i > -1;
  }), Object.assign || Object.defineProperty(Object, "assign", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function (t) {
      if (null == t) throw new TypeError("Cannot convert first argument to object");

      for (var e = Object(t), i = 1; i < arguments.length; i++) {
        var s = arguments[i];

        if (null != s) {
          s = Object(s);

          for (var a = Object.keys(Object(s)), n = 0, r = a.length; n < r; n++) {
            var o = a[n],
                h = Object.getOwnPropertyDescriptor(s, o);
            void 0 !== h && h.enumerable && (e[o] = s[o]);
          }
        }
      }

      return e;
    }
  });

  var t = function (t) {
    return function (t) {
      return !!t && "object" == typeof t;
    }(t) && !function (t) {
      var i = Object.prototype.toString.call(t);
      return "[object RegExp]" === i || "[object Date]" === i || function (t) {
        return t instanceof Node;
      }(t) || function (t) {
        return t.$$typeof === e;
      }(t);
    }(t);
  };

  var e = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

  function i(t, e) {
    return !1 !== e.clone && e.isMergeableObject(t) ? o((i = t, Array.isArray(i) ? [] : {}), t, e) : t;
    var i;
  }

  function s(t, e, s) {
    return t.concat(e).map(function (t) {
      return i(t, s);
    });
  }

  function a(t) {
    return Object.keys(t).concat(function (t) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t).filter(function (e) {
        return t.propertyIsEnumerable(e);
      }) : [];
    }(t));
  }

  function n(t, e) {
    try {
      return e in t;
    } catch (t) {
      return !1;
    }
  }

  function r(t, e, s) {
    var r = {};
    return s.isMergeableObject(t) && a(t).forEach(function (e) {
      r[e] = i(t[e], s);
    }), a(e).forEach(function (a) {
      (function (t, e) {
        return n(t, e) && !(Object.hasOwnProperty.call(t, e) && Object.propertyIsEnumerable.call(t, e));
      })(t, a) || (n(t, a) && s.isMergeableObject(e[a]) ? r[a] = function (t, e) {
        if (!e.customMerge) return o;
        var i = e.customMerge(t);
        return "function" == typeof i ? i : o;
      }(a, s)(t[a], e[a], s) : r[a] = i(e[a], s));
    }), r;
  }

  var o = function (e, a, n) {
    (n = n || {}).arrayMerge = n.arrayMerge || s, n.isMergeableObject = n.isMergeableObject || t, n.cloneUnlessOtherwiseSpecified = i;
    var o = Array.isArray(a);
    return o === Array.isArray(e) ? o ? n.arrayMerge(e, a, n) : r(e, a, n) : i(a, n);
  },
      h = function (t) {
    return "object" == typeof t && void 0 !== t.nodeType ? t : "string" == typeof t ? document.querySelector(t) : null;
  },
      l = function (t, e, i, s) {
    void 0 === s && (s = !1);
    var a = document.createElement(t);
    return i && (a[s ? "innerHTML" : "textContent"] = i), e && (a.className = e), a;
  },
      c = function (t) {
    t.parentNode.removeChild(t);
  },
      u = function (t, e, i) {
    return void 0 === i && (i = !1), i ? o(t, e) : Object.assign(t, e);
  },
      p = function (t, e) {
    return t.toLowerCase() + ":to:" + e.toLowerCase();
  },
      d = function (t, e) {
    Object.assign(t.prototype, e);
  };

  function f(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, m(t, e);
  }

  function m(t, e) {
    return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, m(t, e);
  }

  function g(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function v(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var i = 0, s = new Array(e); i < e; i++) s[i] = t[i];

    return s;
  }

  function y(t, e) {
    var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (i) return (i = i.call(t)).next.bind(i);

    if (Array.isArray(t) || (i = function (t, e) {
      if (t) {
        if ("string" == typeof t) return v(t, e);
        var i = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? v(t, e) : void 0;
      }
    }(t)) || e && t && "number" == typeof t.length) {
      i && (t = i);
      var s = 0;
      return function () {
        return s >= t.length ? {
          done: !0
        } : {
          done: !1,
          value: t[s++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var b = function () {
    function t(t, e) {
      (this || _global).node = this._createElement(t), e && this.set(e);
    }

    var e = t.prototype;
    return e._createElement = function (t) {
      return document.createElementNS("http://www.w3.org/2000/svg", t);
    }, e.addClass = function (t) {
      (this || _global).node.setAttribute("class", t);
    }, e.getBBox = function () {
      return (this || _global).node.getBBox();
    }, e.set = function (t, e) {
      if ("object" == typeof t) for (var i in t) this.applyAttr(i, t[i]);else this.applyAttr(t, e);
    }, e.get = function (t) {
      return (this || _global).style.initial[t];
    }, e.applyAttr = function (t, e) {
      (this || _global).node.setAttribute(t.replace(/[\w]([A-Z])/g, function (t) {
        return t[0] + "-" + t[1];
      }).toLowerCase(), e);
    }, e.remove = function () {
      c((this || _global).node);
    }, t;
  }(),
      _ = function (t) {
    function e(e, i, s) {
      var a;
      return void 0 === s && (s = {}), (a = t.call(this || _global, e, i) || this || _global).isHovered = !1, a.isSelected = !1, a.style = s, a.style.current = {}, a.updateStyle(), a;
    }

    f(e, t);
    var i = e.prototype;
    return i.setStyle = function (t, e) {
      var i;
      "object" == typeof t ? u((this || _global).style.current, t) : u((this || _global).style.current, ((i = {})[t] = e, i));
      this.updateStyle();
    }, i.updateStyle = function () {
      var t = {};
      u(t, (this || _global).style.initial), u(t, (this || _global).style.current), (this || _global).isHovered && u(t, (this || _global).style.hover), (this || _global).isSelected && (u(t, (this || _global).style.selected), (this || _global).isHovered && u(t, (this || _global).style.selectedHover)), this.set(t);
    }, e;
  }(b),
      S = function (t) {
    function e(e, i) {
      return t.call(this || _global, "text", e, i) || this || _global;
    }

    return f(e, t), e.prototype.applyAttr = function (e, i) {
      "text" === e ? (this || _global).node.textContent = i : t.prototype.applyAttr.call(this || _global, e, i);
    }, e;
  }(_),
      w = function (t) {
    function e(e, i) {
      return t.call(this || _global, "image", e, i) || this || _global;
    }

    return f(e, t), e.prototype.applyAttr = function (e, i) {
      var s;
      "image" === e ? ("object" == typeof i ? (s = i.url, (this || _global).offset = i.offset || [0, 0]) : (s = i, (this || _global).offset = [0, 0]), (this || _global).node.setAttributeNS("http://www.w3.org/1999/xlink", "href", s), (this || _global).width = 23, (this || _global).height = 23, this.applyAttr("width", (this || _global).width), this.applyAttr("height", (this || _global).height), this.applyAttr("x", (this || _global).cx - (this || _global).width / 2 + (this || _global).offset[0]), this.applyAttr("y", (this || _global).cy - (this || _global).height / 2 + (this || _global).offset[1])) : "cx" == e ? ((this || _global).cx = i, (this || _global).width && this.applyAttr("x", i - (this || _global).width / 2 + (this || _global).offset[0])) : "cy" == e ? ((this || _global).cy = i, (this || _global).height && this.applyAttr("y", i - (this || _global).height / 2 + (this || _global).offset[1])) : t.prototype.applyAttr.apply(this || _global, arguments);
    }, e;
  }(_),
      k = function (t) {
    function e(e) {
      var i;
      return (i = t.call(this || _global, "svg") || this || _global)._container = e, i._defsElement = new b("defs"), i._rootElement = new b("g", {
        id: "jvm-regions-group"
      }), i.node.appendChild(i._defsElement.node), i.node.appendChild(i._rootElement.node), i._container.appendChild(i.node), i;
    }

    f(e, t);
    var i = e.prototype;
    return i.setSize = function (t, e) {
      (this || _global).node.setAttribute("width", t), (this || _global).node.setAttribute("height", e);
    }, i.applyTransformParams = function (t, e, i) {
      (this || _global)._rootElement.node.setAttribute("transform", "scale(" + t + ") translate(" + e + ", " + i + ")");
    }, i.createPath = function (t, e) {
      var i = new _("path", t, e);
      return i.node.setAttribute("fill-rule", "evenodd"), this.add(i);
    }, i.createCircle = function (t, e, i) {
      var s = new _("circle", t, e);
      return this.add(s, i);
    }, i.createLine = function (t, e, i) {
      var s = new _("line", t, e);
      return this.add(s, i);
    }, i.createText = function (t, e, i) {
      var s = new S(t, e);
      return this.add(s, i);
    }, i.createImage = function (t, e, i) {
      var s = new w(t, e);
      return this.add(s, i);
    }, i.createGroup = function (t) {
      var e = new b("g");
      return (this || _global).node.appendChild(e.node), t && (e.node.id = t), e.canvas = this || _global, e;
    }, i.add = function (t, e) {
      return (e = e || (this || _global)._rootElement).node.appendChild(t.node), t;
    }, e;
  }(b),
      x = {},
      M = 1,
      j = {
    on: function (t, e, i, s) {
      void 0 === s && (s = {});
      var a = "jvm:" + e + "::" + M++;
      x[a] = {
        selector: t,
        handler: i
      }, i._uid = a, t.addEventListener(e, i, s);
    },
    delegate: function (t, e, i, s) {
      (e = e.split(" ")).forEach(function (e) {
        j.on(t, e, function (t) {
          var e = t.target;
          e.matches(i) && s.call(e, t);
        });
      });
    },
    off: function (t, e, i) {
      var s = e.split(":")[1];
      t.removeEventListener(s, i), delete x[i._uid];
    },
    flush: function () {
      Object.keys(x).forEach(function (t) {
        j.off(x[t].selector, t, x[t].handler);
      });
    },
    getEventRegistry: function () {
      return x;
    }
  };

  var C = {
    onViewportChange: "viewport:changed",
    onRegionClick: "region:clicked",
    onMarkerClick: "marker:clicked",
    onRegionSelected: "region:selected",
    onMarkerSelected: "marker:selected",
    onRegionTooltipShow: "region.tooltip:show",
    onMarkerTooltipShow: "marker.tooltip:show",
    onLoaded: "map:loaded",
    onDestroyed: "map:destroyed"
  };

  function L(t, e, i) {
    var s = h(e),
        a = -1 === s.getAttribute("class").indexOf("jvm-region") ? "marker" : "region",
        n = "region" === a ? s.getAttribute("data-code") : s.getAttribute("data-index"),
        r = a + ":selected";
    return i && (r = a + ".tooltip:show"), {
      event: r,
      type: a,
      code: n,
      element: "region" === a ? t.regions[n].element : t.markers[n].element,
      tooltipText: "region" === a ? t.mapData.paths[n].name || "" : t.markers[n].config.name || ""
    };
  }

  var O = function () {
    function t() {}

    return t.prototype.dispose = function () {
      (this || _global)._tooltip ? c((this || _global)._tooltip) : (this || _global).shape.remove();

      for (var t, e = y(Object.getOwnPropertyNames(this || _global)); !(t = e()).done;) {
        (this || _global)[t.value] = null;
      }
    }, t;
  }(),
      A = {
    getLabelText: function (t, e) {
      if (e) {
        if ("function" == typeof e.render) {
          var i = [];
          return (this || _global).config && (this || _global).config.marker && i.push((this || _global).config.marker), i.push(t), e.render.apply(this || _global, i);
        }

        return t;
      }
    },
    getLabelOffsets: function (t, e) {
      return "function" == typeof e.offsets ? e.offsets(t) : Array.isArray(e.offsets) ? e.offsets[t] : [0, 0];
    },
    setStyle: function (t, e) {
      (this || _global).shape.setStyle(t, e);
    },
    remove: function () {
      (this || _global).shape.remove(), (this || _global).label && (this || _global).label.remove();
    },
    hover: function (t) {
      this._setStatus("isHovered", t);
    },
    select: function (t) {
      this._setStatus("isSelected", t);
    },
    _setStatus: function (t, e) {
      (this || _global).shape[t] = e, (this || _global).shape.updateStyle(), (this || _global)[t] = e, (this || _global).label && ((this || _global).label[t] = e, (this || _global).label.updateStyle());
    }
  },
      X = function (t) {
    function e(e) {
      var i,
          s = e.map,
          a = e.code,
          n = e.path,
          r = e.style,
          o = e.label,
          h = e.labelStyle,
          l = e.labelsGroup;
      (i = t.call(this || _global) || this || _global)._map = s, i.shape = i._createRegion(n, a, r);
      var c = i.shape.getBBox(),
          u = i.getLabelText(a, o);

      if (o && u) {
        var p = i.getLabelOffsets(a);
        i.labelX = c.x + c.width / 2 + p[0], i.labelY = c.y + c.height / 2 + p[1], i.label = i._map.canvas.createText({
          text: u,
          textAnchor: "middle",
          alignmentBaseline: "central",
          dataCode: a,
          x: i.labelX,
          y: i.labelY
        }, h, l), i.label.addClass("jvm-region jvm-element");
      }

      return i;
    }

    f(e, t);
    var i = e.prototype;
    return i._createRegion = function (t, e, i) {
      return (t = (this || _global)._map.canvas.createPath({
        d: t,
        dataCode: e
      }, i)).addClass("jvm-region jvm-element"), t;
    }, i.updateLabelPosition = function () {
      (this || _global).label && (this || _global).label.set({
        x: (this || _global).labelX * (this || _global)._map.scale + (this || _global)._map.transX * (this || _global)._map.scale,
        y: (this || _global).labelY * (this || _global)._map.scale + (this || _global)._map.transY * (this || _global)._map.scale
      });
    }, e;
  }(O);

  d(X, A);

  var Y = function (t) {
    function e(e) {
      var i,
          s = e.index,
          a = e.map,
          n = e.style,
          r = e.x1,
          o = e.y1,
          h = e.x2,
          l = e.y2,
          c = e.group,
          u = e.config;
      return (i = t.call(this || _global) || this || _global).config = u, i.shape = a.canvas.createLine({
        x1: r,
        y1: o,
        x2: h,
        y2: l,
        dataIndex: s
      }, n, c), i.shape.addClass("jvm-line"), i;
    }

    return f(e, t), e.prototype.setStyle = function (t, e) {
      (this || _global).shape.setStyle(t, e);
    }, e;
  }(O);

  var E = function (t) {
    function e(e) {
      var i,
          s = e.index,
          a = e.style,
          n = e.label,
          r = e.cx,
          o = e.cy,
          h = e.map,
          l = e.group;
      return (i = t.call(this || _global) || this || _global)._map = h, i._isImage = !!a.initial.image, i.config = arguments[0], i.shape = h.canvas[i._isImage ? "createImage" : "createCircle"]({
        dataIndex: s,
        cx: r,
        cy: o
      }, i._getStyle(), l), i.shape.addClass("jvm-marker jvm-element"), i._isImage && i.updateLabelPosition(), n && i._createLabel(i.config), i;
    }

    f(e, t);
    var i = e.prototype;
    return i.updateLabelPosition = function () {
      (this || _global).label && (this || _global).label.set({
        x: (this || _global)._labelX * (this || _global)._map.scale + (this || _global)._offsets[0] + (this || _global)._map.transX * (this || _global)._map.scale + 5 + ((this || _global)._isImage ? ((this || _global).shape.width || 0) / 2 : (this || _global).shape.node.r.baseVal.value),
        y: (this || _global)._labelY * (this || _global)._map.scale + (this || _global)._map.transY * (this || _global)._map.scale + (this || _global)._offsets[1]
      });
    }, i._createLabel = function (t) {
      var e = t.index,
          i = t.map,
          s = t.label,
          a = t.labelsGroup,
          n = t.cx,
          r = t.cy,
          o = t.marker,
          h = t.isRecentlyCreated,
          l = this.getLabelText(e, s);
      (this || _global)._labelX = n / i.scale - i.transX, (this || _global)._labelY = r / i.scale - i.transY, (this || _global)._offsets = h && o.offsets ? o.offsets : this.getLabelOffsets(e, s), (this || _global).label = i.canvas.createText({
        text: l,
        dataIndex: e,
        x: (this || _global)._labelX,
        y: (this || _global)._labelY,
        dy: "0.6ex"
      }, i.params.markerLabelStyle, a), (this || _global).label.addClass("jvm-marker jvm-element"), h && this.updateLabelPosition();
    }, i._getStyle = function () {
      var t = {};
      return (this || _global)._isImage ? t.initial = {
        image: (this || _global).config.style.initial.image
      } : t = (this || _global).config.style, t;
    }, e;
  }(O);

  d(E, A);

  var T = function () {
    function t(t) {
      void 0 === t && (t = {}), (this || _global)._options = t, (this || _global)._map = (this || _global)._options.map, (this || _global)._series = (this || _global)._options.series, (this || _global)._body = l("div", "jvm-legend"), (this || _global)._options.cssClass && (this || _global)._body.setAttribute("class", (this || _global)._options.cssClass), t.vertical ? (this || _global)._map.legendVertical.appendChild((this || _global)._body) : (this || _global)._map.legendHorizontal.appendChild((this || _global)._body), this.render();
    }

    return t.prototype.render = function () {
      var t,
          e,
          i,
          s,
          a = (this || _global)._series.scale.getTicks(),
          n = l("div", "jvm-legend-inner");

      if ((this || _global)._body.innderHTML = "", (this || _global)._options.title) {
        var r = l("div", "jvm-legend-title", (this || _global)._options.title);

        (this || _global)._body.appendChild(r);
      }

      (this || _global)._body.appendChild(n);

      for (var o = 0; o < a.length; o++) {
        switch (t = l("div", "jvm-legend-tick"), e = l("div", "jvm-legend-tick-sample"), (this || _global)._series.config.attribute) {
          case "fill":
            s = a[o].value, /\.(jpg|gif|png)$/.test(s) ? e.style.background = "url(" + a[o].value + ")" : e.style.background = a[o].value;
            break;

          case "stroke":
            e.style.background = a[o].value;
            break;

          case "image":
            e.style.background = "url(" + ("object" == typeof a[o].value ? a[o].value.url : a[o].value) + ") no-repeat center center", e.style.backgroundSize = "cover";
        }

        t.appendChild(e), i = a[o].label, (this || _global)._options.labelRender && (i = (this || _global)._options.labelRender(i));
        var h = l("div", "jvm-legend-tick-text", i);
        t.appendChild(h), n.appendChild(t);
      }
    }, t;
  }(),
      z = function () {
    function t(t) {
      (this || _global)._scale = t;
    }

    var e = t.prototype;
    return e.getValue = function (t) {
      return (this || _global)._scale[t];
    }, e.getTicks = function () {
      var t = [];

      for (var e in (this || _global)._scale) t.push({
        label: e,
        value: (this || _global)._scale[e]
      });

      return t;
    }, t;
  }(),
      P = function () {
    function t(t, e, i) {
      void 0 === t && (t = {}), (this || _global)._map = i, (this || _global)._elements = e, (this || _global)._values = t.values || {}, (this || _global).config = t, (this || _global).config.attribute = t.attribute || "fill", t.attributes && this.setAttributes(t.attributes), "object" == typeof t.scale && ((this || _global).scale = new z(t.scale)), (this || _global).config.legend && ((this || _global).legend = new T(u({
        map: (this || _global)._map,
        series: this || _global
      }, (this || _global).config.legend))), this.setValues((this || _global)._values);
    }

    var e = t.prototype;
    return e.setValues = function (t) {
      var e = {};

      for (var i in t) t[i] && (e[i] = (this || _global).scale.getValue(t[i]));

      this.setAttributes(e);
    }, e.setAttributes = function (t) {
      for (var e in t) (this || _global)._elements[e] && (this || _global)._elements[e].element.setStyle((this || _global).config.attribute, t[e]);
    }, e.clear = function () {
      var t,
          e = {};

      for (t in (this || _global)._values) (this || _global)._elements[t] && (e[t] = (this || _global)._elements[t].element.shape.style.initial[(this || _global).config.attribute]);

      this.setAttributes(e), (this || _global)._values = {};
    }, t;
  }();

  var D = {
    mill: function (t, e, i) {
      return {
        x: (this || _global).radius * (e - i) * (this || _global).radDeg,
        y: -(this || _global).radius * Math.log(Math.tan((45 + 0.4 * t) * (this || _global).radDeg)) / 0.8
      };
    },
    merc: function (t, e, i) {
      return {
        x: (this || _global).radius * (e - i) * (this || _global).radDeg,
        y: -(this || _global).radius * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))
      };
    },
    aea: function (t, e, i) {
      var s = i * (this || _global).radDeg,
          a = 29.5 * (this || _global).radDeg,
          n = 45.5 * (this || _global).radDeg,
          r = t * (this || _global).radDeg,
          o = e * (this || _global).radDeg,
          h = (Math.sin(a) + Math.sin(n)) / 2,
          l = Math.cos(a) * Math.cos(a) + 2 * h * Math.sin(a),
          c = h * (o - s),
          u = Math.sqrt(l - 2 * h * Math.sin(r)) / h,
          p = Math.sqrt(l - 2 * h * Math.sin(0)) / h;
      return {
        x: u * Math.sin(c) * (this || _global).radius,
        y: -(p - u * Math.cos(c)) * (this || _global).radius
      };
    },
    lcc: function (t, e, i) {
      var s = i * (this || _global).radDeg,
          a = e * (this || _global).radDeg,
          n = 33 * (this || _global).radDeg,
          r = 45 * (this || _global).radDeg,
          o = t * (this || _global).radDeg,
          h = Math.log(Math.cos(n) * (1 / Math.cos(r))) / Math.log(Math.tan(Math.PI / 4 + r / 2) * (1 / Math.tan(Math.PI / 4 + n / 2))),
          l = Math.cos(n) * Math.pow(Math.tan(Math.PI / 4 + n / 2), h) / h,
          c = l * Math.pow(1 / Math.tan(Math.PI / 4 + o / 2), h),
          u = l * Math.pow(1 / Math.tan(Math.PI / 4 + 0), h);
      return {
        x: c * Math.sin(h * (a - s)) * (this || _global).radius,
        y: -(u - c * Math.cos(h * (a - s))) * (this || _global).radius
      };
    }
  };
  D.degRad = 180 / Math.PI, D.radDeg = Math.PI / 180, D.radius = 6381372;

  var I = {
    _setupContainerEvents: function () {
      var t,
          e,
          i = this || _global,
          s = !1,
          a = this || _global;
      (this || _global).params.draggable && (j.on((this || _global).container, "mousemove", function (i) {
        if (!s) return !1;
        a.transX -= (t - i.pageX) / a.scale, a.transY -= (e - i.pageY) / a.scale, a._applyTransform(), t = i.pageX, e = i.pageY;
      }), j.on((this || _global).container, "mousedown", function (i) {
        return s = !0, t = i.pageX, e = i.pageY, !1;
      }), j.on(document.body, "mouseup", function () {
        s = !1;
      })), (this || _global).params.zoomOnScroll && j.on((this || _global).container, "wheel", function (t) {
        var e = 0;
        e = (t.deltaY || -t.wheelDelta || t.detail) >> 10 || 1, e *= 75;
        var s = i.container.getBoundingClientRect(),
            n = t.pageX - s.left - window.pageXOffset,
            r = t.pageY - s.top - window.pageYOffset,
            o = Math.pow(1 + a.params.zoomOnScrollSpeed / 1000, -1.5 * e);
        a.tooltip && a.tooltip.hide(), a._setScale(a.scale * o, n, r), t.preventDefault();
      });
    },
    _setupElementEvents: function () {
      var t,
          e,
          i,
          s = this || _global,
          a = (this || _global).container;
      j.on(a, "mousemove", function (s) {
        Math.abs(t - s.pageX) + Math.abs(e - s.pageY) > 2 && (i = !0);
      }), j.delegate(a, "mousedown", ".jvm-element", function (s) {
        t = s.pageX, e = s.pageY, i = !1;
      }), j.delegate(a, "mouseover mouseout", ".jvm-element", function (t) {
        var e = L(s, this || _global, !0),
            i = s.params.showTooltip;
        "mouseover" === t.type ? (e.element.hover(!0), s.tooltip.text(e.tooltipText), s._emit(e.event, [t, s.tooltip, e.code]), t.defaultPrevented || i && s.tooltip.show()) : (e.element.hover(!1), i && s.tooltip.hide());
      }), j.delegate(a, "mouseup", ".jvm-element", function (t) {
        var e = L(s, this || _global);

        if (!i && ("region" === e.type && s.params.regionsSelectable || "marker" === e.type && s.params.markersSelectable)) {
          var a = e.element;
          s.params[e.type + "sSelectableOne"] && s._clearSelected(e.type + "s"), e.element.isSelected ? a.select(!1) : a.select(!0), s._emit(e.event, [e.code, a.isSelected, s._getSelected(e.type + "s")]);
        }
      }), j.delegate(a, "click", ".jvm-element", function (t) {
        var e = L(s, this || _global),
            i = e.type,
            a = e.code;

        s._emit("region" === i ? C.onRegionClick : C.onMarkerClick, [t, a]);
      });
    },
    _setupZoomButtons: function () {
      var t = this || _global,
          e = this || _global,
          i = l("div", "jvm-zoom-btn jvm-zoomin", "&#43;", !0),
          s = l("div", "jvm-zoom-btn jvm-zoomout", "&#x2212", !0);
      (this || _global).container.appendChild(i), (this || _global).container.appendChild(s), j.on(i, "click", function () {
        t._setScale(e.scale * e.params.zoomStep, e.width / 2, e.height / 2, !1, e.params.zoomAnimate);
      }), j.on(s, "click", function () {
        t._setScale(e.scale / e.params.zoomStep, e.width / 2, e.height / 2, !1, e.params.zoomAnimate);
      });
    },
    _setupContainerTouchEvents: function () {
      var t,
          e,
          i,
          s,
          a,
          n,
          r,
          o = this || _global,
          h = function (h) {
        var l,
            c,
            u,
            p,
            d = h.touches;
        if ("touchstart" == h.type && (r = 0), 1 == d.length) 1 == r && (u = o.transX, p = o.transY, o.transX -= (i - d[0].pageX) / o.scale, o.transY -= (s - d[0].pageY) / o.scale, o.tooltip.hide(), o._applyTransform(), u == o.transX && p == o.transY || h.preventDefault()), i = d[0].pageX, s = d[0].pageY;else if (2 == d.length) if (2 == r) c = Math.sqrt(Math.pow(d[0].pageX - d[1].pageX, 2) + Math.pow(d[0].pageY - d[1].pageY, 2)) / e, o._setScale(t * c, a, n), o.tooltip.hide(), h.preventDefault();else {
          var f = o.container.selector.getBoundingClientRect();
          l = {
            top: f.top + window.scrollY,
            left: f.left + window.scrollX
          }, a = d[0].pageX > d[1].pageX ? d[1].pageX + (d[0].pageX - d[1].pageX) / 2 : d[0].pageX + (d[1].pageX - d[0].pageX) / 2, n = d[0].pageY > d[1].pageY ? d[1].pageY + (d[0].pageY - d[1].pageY) / 2 : d[0].pageY + (d[1].pageY - d[0].pageY) / 2, a -= l.left, n -= l.top, t = o.scale, e = Math.sqrt(Math.pow(d[0].pageX - d[1].pageX, 2) + Math.pow(d[0].pageY - d[1].pageY, 2));
        }
        r = d.length;
      };

      j.on(o.container, "touchstart", h), j.on(o.container, "touchmove", h);
    },
    _createRegions: function () {
      var t, e;

      for (t in (this || _global).regionLabelsGroup = (this || _global).regionLabelsGroup || (this || _global).canvas.createGroup("jvm-regions-labels-group"), (this || _global).mapData.paths) e = new X({
        map: this || _global,
        code: t,
        path: (this || _global).mapData.paths[t].path,
        style: u({}, (this || _global).params.regionStyle),
        labelStyle: (this || _global).params.regionLabelStyle,
        labelsGroup: (this || _global).regionLabelsGroup,
        label: (this || _global).params.labels && (this || _global).params.labels.regions
      }), (this || _global).regions[t] = {
        config: (this || _global).mapData.paths[t],
        element: e
      };
    },
    _createLines: function (t, e, i) {
      void 0 === i && (i = !1);
      var s = !1,
          a = !1;

      for (var n in (this || _global).linesGroup = (this || _global).linesGroup || (this || _global).canvas.createGroup("jvm-lines-group"), t) {
        var r = t[n];

        for (var o in e) {
          var h = i ? e[o].config : e[o];
          h.name === r.from && (s = this.getMarkerPosition(h)), h.name === r.to && (a = this.getMarkerPosition(h));
        }

        !1 !== s && !1 !== a && ((this || _global).lines[p(r.from, r.to)] = new Y({
          index: n,
          map: this || _global,
          style: u({
            initial: (this || _global).params.lineStyle
          }, {
            initial: r.style || {}
          }, !0),
          x1: s.x,
          y1: s.y,
          x2: a.x,
          y2: a.y,
          group: (this || _global).linesGroup,
          config: r
        }));
      }
    },
    _createMarkers: function (t, e) {
      var i,
          s,
          a,
          n,
          r = this || _global;

      for (var o in void 0 === t && (t = {}), void 0 === e && (e = !1), (this || _global).markersGroup = (this || _global).markersGroup || (this || _global).canvas.createGroup("jvm-markers-group"), (this || _global).markerLabelsGroup = (this || _global).markerLabelsGroup || (this || _global).canvas.createGroup("jvm-markers-labels-group"), t) {
        if (i = t[o], a = this.getMarkerPosition(i), n = i.coords.join(":"), e) {
          if (Object.keys((this || _global).markers).filter(function (t) {
            return r.markers[t]._uid === n;
          }).length) continue;
          o = Object.keys((this || _global).markers).length;
        }

        !1 !== a && (s = new E({
          index: o,
          map: this || _global,
          style: u((this || _global).params.markerStyle, {
            initial: i.style || {}
          }, !0),
          label: (this || _global).params.labels && (this || _global).params.labels.markers,
          labelsGroup: (this || _global).markerLabelsGroup,
          cx: a.x,
          cy: a.y,
          group: (this || _global).markersGroup,
          marker: i,
          isRecentlyCreated: e
        }), (this || _global).markers[o] && this.removeMarkers([o]), (this || _global).markers[o] = {
          _uid: n,
          config: i,
          element: s
        });
      }
    },
    _createSeries: function () {
      for (var t in (this || _global).series = {
        markers: [],
        regions: []
      }, (this || _global).params.series) for (var e = 0; e < (this || _global).params.series[t].length; e++) (this || _global).series[t][e] = new P((this || _global).params.series[t][e], (this || _global)[t], this || _global);
    },
    _applyTransform: function () {
      var t, e, i, s;
      (this || _global).defaultWidth * (this || _global).scale <= (this || _global).width ? (t = ((this || _global).width - (this || _global).defaultWidth * (this || _global).scale) / (2 * (this || _global).scale), i = ((this || _global).width - (this || _global).defaultWidth * (this || _global).scale) / (2 * (this || _global).scale)) : (t = 0, i = ((this || _global).width - (this || _global).defaultWidth * (this || _global).scale) / (this || _global).scale), (this || _global).defaultHeight * (this || _global).scale <= (this || _global).height ? (e = ((this || _global).height - (this || _global).defaultHeight * (this || _global).scale) / (2 * (this || _global).scale), s = ((this || _global).height - (this || _global).defaultHeight * (this || _global).scale) / (2 * (this || _global).scale)) : (e = 0, s = ((this || _global).height - (this || _global).defaultHeight * (this || _global).scale) / (this || _global).scale), (this || _global).transY > e ? (this || _global).transY = e : (this || _global).transY < s && ((this || _global).transY = s), (this || _global).transX > t ? (this || _global).transX = t : (this || _global).transX < i && ((this || _global).transX = i), (this || _global).canvas.applyTransformParams((this || _global).scale, (this || _global).transX, (this || _global).transY), (this || _global).markers && this._repositionMarkers(), (this || _global).lines && this._repositionLines(), this._repositionLabels();
    },
    _resize: function () {
      var t = (this || _global).baseScale;
      (this || _global).width / (this || _global).height > (this || _global).defaultWidth / (this || _global).defaultHeight ? ((this || _global).baseScale = (this || _global).height / (this || _global).defaultHeight, (this || _global).baseTransX = Math.abs((this || _global).width - (this || _global).defaultWidth * (this || _global).baseScale) / (2 * (this || _global).baseScale)) : ((this || _global).baseScale = (this || _global).width / (this || _global).defaultWidth, (this || _global).baseTransY = Math.abs((this || _global).height - (this || _global).defaultHeight * (this || _global).baseScale) / (2 * (this || _global).baseScale)), (this || _global).scale *= (this || _global).baseScale / t, (this || _global).transX *= (this || _global).baseScale / t, (this || _global).transY *= (this || _global).baseScale / t;
    },
    _setScale: function (t, e, i, s, a) {
      var n,
          r,
          o,
          h,
          l,
          c,
          u,
          p,
          d,
          f,
          m = this || _global,
          g = 0,
          v = Math.abs(Math.round(60 * (t - (this || _global).scale) / Math.max(t, (this || _global).scale)));
      t > (this || _global).params.zoomMax * (this || _global).baseScale ? t = (this || _global).params.zoomMax * (this || _global).baseScale : t < (this || _global).params.zoomMin * (this || _global).baseScale && (t = (this || _global).params.zoomMin * (this || _global).baseScale), void 0 !== e && void 0 !== i && (n = t / (this || _global).scale, s ? (d = e + (this || _global).defaultWidth * ((this || _global).width / ((this || _global).defaultWidth * t)) / 2, f = i + (this || _global).defaultHeight * ((this || _global).height / ((this || _global).defaultHeight * t)) / 2) : (d = (this || _global).transX - (n - 1) / t * e, f = (this || _global).transY - (n - 1) / t * i)), a && v > 0 ? (o = (this || _global).scale, h = (t - o) / v, l = (this || _global).transX * (this || _global).scale, u = (this || _global).transY * (this || _global).scale, c = (d * t - l) / v, p = (f * t - u) / v, r = setInterval(function () {
        g += 1, m.scale = o + h * g, m.transX = (l + c * g) / m.scale, m.transY = (u + p * g) / m.scale, m._applyTransform(), g == v && (clearInterval(r), m._emit(C.onViewportChange, [m.scale, m.transX, m.transY]));
      }, 10)) : ((this || _global).transX = d, (this || _global).transY = f, (this || _global).scale = t, this._applyTransform(), this._emit(C.onViewportChange, [(this || _global).scale, (this || _global).transX, (this || _global).transY]));
    },
    setFocus: function (t) {
      var e = this || _global;
      void 0 === t && (t = {});
      var i,
          s = [];
      if (t.region ? s.push(t.region) : t.regions && (s = t.regions), s.length) return s.forEach(function (t) {
        if (e.regions[t]) {
          var s = e.regions[t].element.shape.getBBox();
          s && (i = void 0 === i ? s : {
            x: Math.min(i.x, s.x),
            y: Math.min(i.y, s.y),
            width: Math.max(i.x + i.width, s.x + s.width) - Math.min(i.x, s.x),
            height: Math.max(i.y + i.height, s.y + s.height) - Math.min(i.y, s.y)
          });
        }
      }), this._setScale(Math.min((this || _global).width / i.width, (this || _global).height / i.height), -(i.x + i.width / 2), -(i.y + i.height / 2), !0, t.animate);

      if (t.coords) {
        var a = this.coordsToPoint(t.coords[0], t.coords[1]),
            n = (this || _global).transX - a.x / (this || _global).scale,
            r = (this || _global).transY - a.y / (this || _global).scale;
        return this._setScale(t.scale * (this || _global).baseScale, n, r, !0, t.animate);
      }
    },
    updateSize: function () {
      (this || _global).width = (this || _global).container.offsetWidth, (this || _global).height = (this || _global).container.offsetHeight, this._resize(), (this || _global).canvas.setSize((this || _global).width, (this || _global).height), this._applyTransform();
    },
    coordsToPoint: function (t, e) {
      var i,
          s,
          a,
          n = V.maps[(this || _global).params.map].projection,
          r = n.centralMeridian;
      return i = D[n.type](t, e, r), !!(s = this.getInsetForPoint(i.x, i.y)) && (a = s.bbox, i.x = (i.x - a[0].x) / (a[1].x - a[0].x) * s.width * (this || _global).scale, i.y = (i.y - a[0].y) / (a[1].y - a[0].y) * s.height * (this || _global).scale, {
        x: i.x + (this || _global).transX * (this || _global).scale + s.left * (this || _global).scale,
        y: i.y + (this || _global).transY * (this || _global).scale + s.top * (this || _global).scale
      });
    },
    getInsetForPoint: function (t, e) {
      var i,
          s,
          a = V.maps[(this || _global).params.map].insets;

      for (i = 0; i < a.length; i++) if (t > (s = a[i].bbox)[0].x && t < s[1].x && e > s[0].y && e < s[1].y) return a[i];
    },
    getMarkerPosition: function (t) {
      var e = t.coords;
      return V.maps[(this || _global).params.map].projection ? (this || _global).coordsToPoint.apply(this || _global, e) : {
        x: e[0] * (this || _global).scale + (this || _global).transX * (this || _global).scale,
        y: e[1] * (this || _global).scale + (this || _global).transY * (this || _global).scale
      };
    },
    _repositionLines: function () {
      var t = !1,
          e = !1;

      for (var i in (this || _global).lines) {
        for (var s in (this || _global).markers) {
          var a = (this || _global).markers[s];
          a.config.name === (this || _global).lines[i].config.from && (t = this.getMarkerPosition(a.config)), a.config.name === (this || _global).lines[i].config.to && (e = this.getMarkerPosition(a.config));
        }

        !1 !== t && !1 !== e && (this || _global).lines[i].setStyle({
          x1: t.x,
          y1: t.y,
          x2: e.x,
          y2: e.y
        });
      }
    },
    _repositionMarkers: function () {
      var t;

      for (var e in (this || _global).markers) !1 !== (t = this.getMarkerPosition((this || _global).markers[e].config)) && (this || _global).markers[e].element.setStyle({
        cx: t.x,
        cy: t.y
      });
    },
    _repositionLabels: function () {
      var t = (this || _global).params.labels;

      if (t) {
        if (t.regions) for (var e in (this || _global).regions) (this || _global).regions[e].element.updateLabelPosition();
        if (t.markers) for (var i in (this || _global).markers) (this || _global).markers[i].element.updateLabelPosition();
      }
    }
  },
      R = function (t) {
    function e(e) {
      var i;
      i = t.call(this || _global) || this || _global;
      var s = l("div", "jvm-tooltip");
      return i._map = e, i._tooltip = document.body.appendChild(s), i._bindEventListeners(), g(i) || g(i);
    }

    f(e, t);
    var i = e.prototype;
    return i._bindEventListeners = function () {
      var t = this || _global;
      j.on((this || _global)._map.container, "mousemove", function (e) {
        if (t._tooltip.classList.contains("active")) {
          var i,
              s,
              a = (i = t._map.container, s = "#jvm-regions-group", Element.prototype.querySelector.call(i, s)).getBoundingClientRect(),
              n = t._tooltip.getBoundingClientRect(),
              r = n.height,
              o = n.width,
              h = e.clientY <= a.top + r + 5,
              l = e.pageY - r - 5,
              c = e.pageX - o - 5;

          h && (l += r + 5, c -= 10), e.clientX < a.left + o + 5 && (c = e.pageX + 5 + 2, h && (c += 10)), t.css({
            top: l + "px",
            left: c + "px"
          });
        }
      });
    }, i.getElement = function () {
      return (this || _global)._tooltip;
    }, i.show = function () {
      (this || _global)._tooltip.classList.add("active");
    }, i.hide = function () {
      (this || _global)._tooltip.classList.remove("active");
    }, i.text = function (t) {
      if (!t) return (this || _global)._tooltip.textContent;
      (this || _global)._tooltip.textContent = t;
    }, i.css = function (t) {
      for (var e in t) (this || _global)._tooltip.style[e] = t[e];

      return this || _global;
    }, e;
  }(O),
      H = function () {
    function t(t, e) {
      var i = t.scale,
          s = t.values;
      (this || _global)._scale = i, (this || _global)._values = s, (this || _global)._fromColor = this.hexToRgb(i[0]), (this || _global)._toColor = this.hexToRgb(i[1]), (this || _global)._map = e, this.setMinMaxValues(s), this.visualize();
    }

    var e = t.prototype;
    return e.setMinMaxValues = function (t) {
      for (var e in (this || _global).min = Number.MAX_VALUE, (this || _global).max = 0, t) (e = parseFloat(t[e])) > (this || _global).max && ((this || _global).max = e), e < (this || _global).min && ((this || _global).min = e);
    }, e.visualize = function () {
      var t,
          e = {};

      for (var i in (this || _global)._values) t = parseFloat((this || _global)._values[i]), isNaN(t) || (e[i] = this.getValue(t));

      this.setAttributes(e);
    }, e.setAttributes = function (t) {
      for (var e in t) (this || _global)._map.regions[e] && (this || _global)._map.regions[e].element.setStyle("fill", t[e]);
    }, e.getValue = function (t) {
      for (var e, i = "#", s = 0; s < 3; s++) i += (1 === (e = Math.round((this || _global)._fromColor[s] + ((this || _global)._toColor[s] - (this || _global)._fromColor[s]) * ((t - (this || _global).min) / ((this || _global).max - (this || _global).min))).toString(16)).length ? "0" : "") + e;

      return i;
    }, e.hexToRgb = function (t) {
      var e = 0,
          i = 0,
          s = 0;
      return 4 == t.length ? (e = "0x" + t[1] + t[1], i = "0x" + t[2] + t[2], s = "0x" + t[3] + t[3]) : 7 == t.length && (e = "0x" + t[1] + t[2], i = "0x" + t[3] + t[4], s = "0x" + t[5] + t[6]), [parseInt(e), parseInt(i), parseInt(s)];
    }, t;
  }(),
      V = function () {
    function t(e) {
      var i = this || _global;
      if (void 0 === e && (e = {}), (this || _global).params = u(t.defaults, e, !0), !t.maps[(this || _global).params.map]) throw new Error("Attempt to use map which was not loaded: " + e.map);
      (this || _global).mapData = t.maps[(this || _global).params.map], (this || _global).regions = {}, (this || _global).markers = {}, (this || _global).lines = {}, (this || _global).defaultWidth = (this || _global).mapData.width, (this || _global).defaultHeight = (this || _global).mapData.height, (this || _global).height = 0, (this || _global).width = 0, (this || _global).scale = 1, (this || _global).baseScale = 1, (this || _global).transX = 0, (this || _global).transY = 0, (this || _global).baseTransX = 0, (this || _global).baseTransY = 0, "loading" !== document.readyState ? this._init() : window.addEventListener("DOMContentLoaded", function () {
        return i._init();
      });
    }

    var e = t.prototype;
    return e._init = function () {
      var t = (this || _global).params;
      (this || _global).container = h(t.selector), (this || _global).container.classList.add("jvm-container"), (this || _global).canvas = new k((this || _global).container), this.setBackgroundColor(t.backgroundColor), this._createRegions(), this.updateSize(), this._createLines(t.lines || {}, t.markers || {}), this._createMarkers(t.markers), this._repositionLabels(), this._setupContainerEvents(), this._setupElementEvents(), t.zoomButtons && this._setupZoomButtons(), t.showTooltip && ((this || _global).tooltip = new R(this || _global)), t.selectedRegions && this._setSelected("regions", t.selectedRegions), t.selectedMarkers && this._setSelected("markers", t.selectedMarkers), t.focusOn && this.setFocus(t.focusOn), t.visualizeData && ((this || _global).dataVisualization = new H(t.visualizeData, this || _global)), t.bindTouchEvents && ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) && this._setupContainerTouchEvents(), t.series && ((this || _global).container.appendChild((this || _global).legendHorizontal = l("div", "jvm-series-container jvm-series-h")), (this || _global).container.appendChild((this || _global).legendVertical = l("div", "jvm-series-container jvm-series-v")), this._createSeries()), this._emit(C.onLoaded, [this || _global]);
    }, e._emit = function (t, e) {
      for (var i in C) C[i] === t && "function" == typeof (this || _global).params[i] && (this || _global).params[i].apply(this || _global, e);
    }, e.setBackgroundColor = function (t) {
      (this || _global).container.style.backgroundColor = t;
    }, e._getSelected = function (t) {
      var e,
          i = [];

      for (e in (this || _global)[t]) (this || _global)[t][e].element.isSelected && i.push(e);

      return i;
    }, e._setSelected = function (t, e) {
      var i = this || _global;
      e.forEach(function (e) {
        i[t][e] && i[t][e].element.select(!0);
      });
    }, e._clearSelected = function (t) {
      var e = this || _global;

      this._getSelected(t).forEach(function (i) {
        e[t][i].element.select(!1);
      });
    }, e.getSelectedRegions = function () {
      return this._getSelected("regions");
    }, e.clearSelectedRegions = function () {
      this._clearSelected("regions");
    }, e.getSelectedMarkers = function () {
      return this._getSelected("markers");
    }, e.clearSelectedMarkers = function () {
      this._clearSelected("markers");
    }, e.addMarkers = function (t) {
      if (Array.isArray(t)) return this._createMarkers(t, !0);

      this._createMarkers([t], !0);
    }, e.removeMarkers = function (t) {
      var e = this || _global;
      t || (t = Object.keys((this || _global).markers)), t.forEach(function (t) {
        e.markers[t].element.remove(), delete e.markers[t];
      });
    }, e.addLine = function (t, e, i) {
      void 0 === i && (i = {}), console.warn("`addLine` method is deprecated, please use `addLines` instead."), this._createLines([{
        from: t,
        to: e,
        style: i
      }], (this || _global).markers, !0);
    }, e.addLines = function (t) {
      var e = this._getLinesAsUids();

      Array.isArray(t) || (t = [t]), this._createLines(t.filter(function (t) {
        return !(e.indexOf(p(t.from, t.to)) > -1);
      }), (this || _global).markers, !0);
    }, e.removeLines = function (t) {
      var e = this || _global;
      (t = Array.isArray(t) ? t.map(function (t) {
        return p(t.from, t.to);
      }) : this._getLinesAsUids()).forEach(function (t) {
        e.lines[t].dispose(), delete e.lines[t];
      });
    }, e._getLinesAsUids = function () {
      return Object.keys((this || _global).lines);
    }, e.removeLine = function (t, e) {
      console.warn("`removeLine` method is deprecated, please use `removeLines` instead.");
      var i = p(t, e);
      (this || _global).lines.hasOwnProperty(i) && ((this || _global).lines[i].element.remove(), delete (this || _global).lines[i]);
    }, e.reset = function () {
      for (var t in (this || _global).series) for (var e = 0; e < (this || _global).series[t].length; e++) (this || _global).series[t][e].clear();

      (this || _global).legendHorizontal && (c((this || _global).legendHorizontal), (this || _global).legendHorizontal = null), (this || _global).legendVertical && (c((this || _global).legendVertical), (this || _global).legendVertical = null), (this || _global).scale = (this || _global).baseScale, (this || _global).transX = (this || _global).baseTransX, (this || _global).transY = (this || _global).baseTransY, this._applyTransform(), this.clearSelectedMarkers(), this.clearSelectedRegions(), this.removeMarkers();
    }, e.destroy = function (t) {
      var e = this || _global;
      void 0 === t && (t = !0), j.flush(), (this || _global).tooltip.dispose(), this._emit(C.onDestroyed), t && Object.keys(this || _global).forEach(function (t) {
        try {
          delete e[t];
        } catch (t) {}
      });
    }, e.extend = function (e, i) {
      if ("function" == typeof (this || _global)[e]) throw new Error("The method [" + e + "] already exists internally please use another name.");
      t.prototype[e] = i;
    }, t;
  }();

  V.maps = {}, V.defaults = {
    map: "world",
    backgroundColor: "transparent",
    draggable: !0,
    zoomButtons: !0,
    zoomOnScroll: !0,
    zoomOnScrollSpeed: 3,
    zoomMax: 12,
    zoomMin: 1,
    zoomAnimate: !0,
    showTooltip: !0,
    zoomStep: 1.5,
    bindTouchEvents: !0,
    lineStyle: {
      stroke: "#808080",
      strokeWidth: 1,
      strokeLinecap: "round"
    },
    markersSelectable: !1,
    markersSelectableOne: !1,
    markerStyle: {
      initial: {
        r: 7,
        fill: "#374151",
        fillOpacity: 1,
        stroke: "#FFF",
        strokeWidth: 5,
        strokeOpacity: 0.5
      },
      hover: {
        fill: "#3cc0ff",
        cursor: "pointer"
      },
      selected: {
        fill: "blue"
      },
      selectedHover: {}
    },
    markerLabelStyle: {
      initial: {
        fontFamily: "Verdana",
        fontSize: 12,
        fontWeight: 500,
        cursor: "default",
        fill: "#374151"
      },
      hover: {
        cursor: "pointer"
      },
      selected: {},
      selectedHover: {}
    },
    regionsSelectable: !1,
    regionsSelectableOne: !1,
    regionStyle: {
      initial: {
        fill: "#dee2e8",
        fillOpacity: 1,
        stroke: "none",
        strokeWidth: 0
      },
      hover: {
        fillOpacity: 0.7,
        cursor: "pointer"
      },
      selected: {
        fill: "#9ca3af"
      },
      selectedHover: {}
    },
    regionLabelStyle: {
      initial: {
        fontFamily: "Verdana",
        fontSize: "12",
        fontWeight: "bold",
        cursor: "default",
        fill: "#35373e"
      },
      hover: {
        cursor: "pointer"
      }
    }
  }, Object.assign(V.prototype, I);

  var G = function () {
    function t(t) {
      if (void 0 === t && (t = {}), !t.selector) throw new Error("Selector is not given.");
      return new V(t);
    }

    return t.addMap = function (t, e) {
      V.maps[t] = e;
    }, t;
  }();

  return window.jsVectorMap = G;
});
export default exports;